import { axios } from '@/services/axios';

const getWholesaler = async (wholesalerId) => {
    const response = await axios.get(`/wholesaler/${wholesalerId}`, {
        headers: {
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
        },
    });

    return response.data;
};

export default getWholesaler;
